var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayrollManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 50.0001C8.3335 34.2866 8.3335 26.4299 13.2151 21.5483C18.0966 16.6667 25.9533 16.6667 41.6668 16.6667H58.3335C74.047 16.6667 81.9037 16.6667 86.7853 21.5483C91.6668 26.4299 91.6668 34.2866 91.6668 50.0001C91.6668 65.7136 91.6668 73.5703 86.7853 78.4519C81.9037 83.3334 74.047 83.3334 58.3335 83.3334H41.6668C25.9533 83.3334 18.0966 83.3334 13.2151 78.4519C8.3335 73.5703 8.3335 65.7136 8.3335 50.0001Z",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 68.75H25",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 56.25H25",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 41.6667L91.6668 41.6667",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3335 62.5001C58.3335 58.5717 58.3335 56.6075 59.5539 55.3871C60.7743 54.1667 62.7385 54.1667 66.6668 54.1667C70.5952 54.1667 72.5594 54.1667 73.7798 55.3871C75.0002 56.6075 75.0002 58.5717 75.0002 62.5001C75.0002 66.4285 75.0002 68.3926 73.7798 69.613C72.5594 70.8334 70.5952 70.8334 66.6668 70.8334C62.7385 70.8334 60.7743 70.8334 59.5539 69.613C58.3335 68.3926 58.3335 66.4285 58.3335 62.5001Z",
    stroke: "#1C274C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollManagement);
export default __webpack_public_path__ + "static/media/PayrollManagement.036f3ca4bc6c85333323f790aad877db.svg";
export { ForwardRef as ReactComponent };